
const state = {
  loadingEvent: false,
  drawerEvent: false,
  currentEvent: null,
  updateCount: 0,
  myAiPhotos: [],
  allPhotos: []
}

const mutations = {
  SET_DRAWER_EVENT: (state, value) => {
    state.drawerEvent = value
  },
  INCREMENT_UPDATE: (state) => {
    state.updateCount++
  },
  SET_MY_AI_PHOTOS: (state, value) => {
    console.log('Inside SET_MY_AI_PHOTOS - value', value)
    state.myAiPhotos = value
  },
  SET_ALL_PHOTOS: (state, value) => {
    console.log('Inside SET_ALL_PHOTOS - value', value)
    state.allPhotos = value
  },
  SET_CURRENT_EVENT: (state, value) => {
    console.log('Inside SET_CURRENT_EVENT - value', value)
    state.currentEvent = value
  },
  SET_LOADING_EVENT: (state, value) => {
    state.loadingEvent = value
  }
}

const getters = {
  GET_DRAWER_EVENT: (state) => state.drawerEvent,
  GET_CURRENT_EVENT: (state) => state.currentEvent,
  GET_MY_AI_PHOTOS: (state) => state.myAiPhotos,
  GET_UPDATE_COUNT: (state) => state.updateCount,
  GET_ALL_PHOTOS: (state) => state.allPhotos,
  GET_LOADING_EVENT: (state) => state.loadingEvent
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
